import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllVehicles = async () => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/vehicles`);
  const contacts = await result.json();
  return contacts;
};

export default fetchAllVehicles;
